import React from 'react';
import star from '../../images/star.svg';
import hollowStar from '../../images/star-hollow.svg';

import styles from './FiveStarRating.css';

const FiveStarRating = (props) => {
    const { value, children, hollow } = props;

    const stars = [];
    for (let i = 0; i < value; i++) {
        stars.push(
            hollow ? (
                <img src={hollowStar} key={i} alt="" />
            ) : (
                <img src={star} key={i} alt="" />
            )
        );
    }

    return (
        <div
            tabIndex="0" /* eslint-disable-line jsx-a11y/no-noninteractive-tabindex */
            role="img"
            aria-label={`${value} out of 5 stars`}
        >
            {stars}
            {children}
            <style jsx>{styles}</style>
        </div>
    );
};

export default FiveStarRating;
